import { useEffect, useState } from 'react';

// Matches the codebase's MOBILE_BREAKPOINT (utils/getDeviceType) and the schedule-view CSS rules.
const MOBILE_QUERY = '(max-width: 767px)';

/** Reactive viewport check (true below the mobile breakpoint), updating on resize. */
const useIsMobile = (): boolean => {
  const [isMobile, setIsMobile] = useState<boolean>(() =>
    typeof window !== 'undefined'
      ? window.matchMedia(MOBILE_QUERY).matches
      : false,
  );

  useEffect(() => {
    if (typeof window === 'undefined') return undefined;
    const mql = window.matchMedia(MOBILE_QUERY);
    const onChange = () => setIsMobile(mql.matches);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, []);

  return isMobile;
};

export default useIsMobile;
